<div class="inicio">

    <div class="grid-container5">
        <button mat-mini-fab matTooltip="Retornas a ver todas las solicitudes" color="accent" (click)="clickGoback()" ><mat-icon style="transform: rotate(180deg);">forward icon</mat-icon></button>
        <div></div>
        <p class="titulo" *ngIf="mostrarTitulo()" >SOLICITUD DE EQUIPO EN ESPERA</p>
        <p class="titulo" *ngIf="!mostrarTitulo()" >DETALLE DE SOLICITUD</p>
    </div>

    <div class="columna_5">
        <div></div><div></div><div></div><div></div>
        <mat-label>
            <mat-label class="texto-negrita" > Fecha de solicitud: </mat-label>
            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.fecha_de_solicitud}}</mat-label>
        </mat-label>

        <div></div><div></div><div></div><div></div>
        <mat-label>
            <mat-label class="texto-negrita" > Última modificación: </mat-label>
            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.fecha_ultima_modificacion}}</mat-label>
        </mat-label>
    </div>

    <form #insertForm="ngForm" [formGroup]="formsolicitudAsigEq">

        <div class="columnas_2__fila_1">
            
            <div class="fondo">
                <div class="columna_1__filas_4">
                    <mat-label class="subtitulo">DATOS DEL EMPLEADO SOLICITADO</mat-label>
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Nombre:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colaborador}}</mat-label>
                    </div>
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Cargo:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colacargo}}</mat-label>
                    </div>
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Oficina:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colasucursal}}</mat-label>
                    </div>
                </div>
            </div>

            <div class="fondo">
                <div class="columna_1__filas_4">
                    <mat-label class="subtitulo">DATOS DEL SOLICITANTE</mat-label>
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Nombre:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solicitante}}</mat-label>
                    </div>
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Cargo:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solicargo}}</mat-label>
                    </div>
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Oficina:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solisucursal}}</mat-label>
                    </div>
                </div>
            </div>

        </div>
        <br>
        <div class="columna_1__fila_1">
            
            <div class="fondo">
                <div class="columna_1__filas_2_v2">
                    <mat-label class="subtitulo"><br> DATOS DE LA SOLICITUD</mat-label>
                    <div class="columnas_2__filas_2">
                        <div class="celda">
                            <br><br>
                            <mat-label class="texto-negrita"> Equipo solicitado: </mat-label>
                            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.equipo_solicitado}}</mat-label>
                        </div>
                        <div class="celda">
                            <br><br>
                            <mat-label class="texto-negrita">Fecha límite: </mat-label>
                            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.fecha_planeada_asignacion}}</mat-label>
                        </div>
                        <div class="celda">
                            <br>
                            <mat-label class="texto-negrita">Uso o descripción del equipo solicitado:</mat-label>
                            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.descripcion}}</mat-label>
                        </div>
                        <div class="celda">
                            <br>
                            <mat-label class="texto-negrita">Comentarios u observaciones: </mat-label>
                            <mat-label class="texto-normal">{{formsolicitudAsigEq.value.observaciones}}</mat-label>
                        </div>
                        <div class="celda">
                            <br>
                            <mat-label class="texto-negrita"> Estado actual: </mat-label>
                            <mat-label class="texto-normal">{{status}}</mat-label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columnas_3__fila_1">
            <button mat-raised-button color="primary" matTooltip="Inicia con la asignación de equipo"           *ngIf="habilitarBotones()" (click)="clickAprovarSolicitud()" >Aprobar<mat-icon>check_circle</mat-icon></button>
            <button mat-raised-button color="warn"    matTooltip="Archiva y marca como cancelada la solicitud" *ngIf="habilitarBotones()" (click)="clickCancelararSolicitud($event)" >Cancelar<mat-icon>cancel</mat-icon></button>
            <button mat-raised-button color="warn"    matTooltip="Marca la solicitud como rechazada"           *ngIf="habilitarBotones()" (click)="clickRechazarSolicitud()">Rechazar<mat-icon>cancel</mat-icon></button>
        </div>

    </form>

</div>